import { intervalToDuration } from 'date-fns';
import { utcToZonedTime, getTimezoneOffset } from 'date-fns-tz';
import { getDefaultFormats } from './DateUtils2.js';
import { getNow } from './DateUtils3.js';

const getTzTodayDate = () => {
    var _a;
    const { timezone } = getDefaultFormats();
    const currentZonedDate = getNow();
    const newDate = utcToZonedTime(currentZonedDate, timezone);
    const offsetMs = getTimezoneOffset(timezone);
    const offsetData = intervalToDuration({ start: 0, end: offsetMs });
    newDate.setUTCHours((offsetMs > 0 ? -1 : 1) * ((_a = offsetData.hours) !== null && _a !== void 0 ? _a : 0), offsetData.minutes, offsetData.seconds, offsetData.seconds);
    const tempDate = new Date(newDate);
    tempDate.setUTCFullYear(currentZonedDate.getUTCFullYear());
    tempDate.setUTCMonth(currentZonedDate.getUTCMonth());
    tempDate.setUTCDate(currentZonedDate.getUTCDate());
    if (tempDate > currentZonedDate)
        return newDate;
    else
        return tempDate;
};

export { getTzTodayDate };
